__turbopack_context__.v({
  "container": "LpProblem2-module__hDlYlq__container",
  "description": "LpProblem2-module__hDlYlq__description",
  "featureItem": "LpProblem2-module__hDlYlq__featureItem",
  "featureText": "LpProblem2-module__hDlYlq__featureText",
  "iconWrapper": "LpProblem2-module__hDlYlq__iconWrapper",
  "leftContent": "LpProblem2-module__hDlYlq__leftContent",
  "rightContent": "LpProblem2-module__hDlYlq__rightContent",
  "section": "LpProblem2-module__hDlYlq__section",
  "title": "LpProblem2-module__hDlYlq__title",
});
